import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import '@utilitywarehouse/hearth-fonts/index.css';
import '@utilitywarehouse/hearth-react/styles.css';
import '@utilitywarehouse/hearth-tokens/css/index.css';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { Debug } from '@components/Debug';
import { ThemeColor } from '@components/ThemeColor';
import { AppProvider } from '@providers/AppProvider';
import '@services/sentry/index.ts';

import { AppShell } from './AppShell';
import './scss/index.scss';
import './scss/overrides.scss';

dayjs.extend(advancedFormat);

if (process.env.NODE_ENV === 'development') {
  loadDevMessages();
  loadErrorMessages();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeColor displayTop />

      <AppProvider>
        <AppShell />
        {import.meta.env.DEV ? <Debug /> : null}
      </AppProvider>
    </HelmetProvider>
  </React.StrictMode>
);
